import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { microAppPathsArraySelector, routesArraySelector, useAppStore, useMicroAppStore } from "../../store";
import { useMemoizedFn } from "ahooks";
import { useEffect } from "react";
import { generatePath, matchRoutes } from "react-router-dom";
export var useMicroAppEventHandle = function useMicroAppEventHandle(microApp) {
  var microApps = useMicroAppStore(function (s) {
    return s.microApps;
  });
  var setMonitorConfig = useMicroAppStore(function (s) {
    return s.setMonitorConfig;
  });
  var monitorConfig = useMicroAppStore(function (s) {
    return s.monitorConfig;
  });
  var microAppPaths = useAppStore(microAppPathsArraySelector);
  var routesPaths = useAppStore(routesArraySelector);
  var pageHandlers = useAppStore(function (s) {
    return s.pageHandlers;
  });

  // 子应用路由改写,有microAppPath的情况下需要变更最终指向的pathname
  var getRealTargetPath = function getRealTargetPath(path) {
    var targetPath = path.split("?");
    var isMicroAppPath = microApps.some(function (app) {
      return path.startsWith(app.baseRoute);
    });
    if (isMicroAppPath) {
      var _ref = matchRoutes(microAppPaths, targetPath[0] || "") || [],
        _ref2 = _slicedToArray(_ref, 1),
        matchWitchMicroAppRoute = _ref2[0];
      // 找到真实的子应用路由解析规则
      if (matchWitchMicroAppRoute && matchWitchMicroAppRoute.route.path !== "*") {
        targetPath[0] = generatePath(matchWitchMicroAppRoute.route.originPath || "", matchWitchMicroAppRoute.params);
      }
    } else {
      var _ref3 = matchRoutes(routesPaths, targetPath[0] || "") || [],
        _ref4 = _slicedToArray(_ref3, 1),
        matchRoute = _ref4[0];
      if (matchRoute) {
        targetPath[0] = generatePath(matchRoute.route.originPath || "", matchRoute.params);
      }
    }
    return targetPath;
  };

  // 处理子应用传递上来的约定事件
  var handleEventFromChild = useMemoizedFn(function (appName, data) {
    var _eventData$tabsHandle, _eventData$tabsHandle2, _eventData$tabsHandle3, _eventData$tabsHandle4, _eventData$tabsHandle5, _eventData$tabsHandle6, _pageHandlers$eventDa;
    var eventData = _objectSpread({}, data);
    var triggerApp = microApps.find(function (app) {
      return app.name === appName;
    });
    // 监控配置事件传递
    var monitorConfigEventKey = Object.keys(data).find(function (el) {
      return el.startsWith("@@monitorConfig_");
    });
    if (monitorConfigEventKey) {
      var host = monitorConfigEventKey.split("@@monitorConfig_")[1];
      if (!monitorConfig[host]) {
        setMonitorConfig(_defineProperty({}, host, data[monitorConfigEventKey]));
      }
    }
    // tabs操作事件传递
    if (!eventData.tabsHandler || !triggerApp) {
      return;
    }
    var path = ((_eventData$tabsHandle = eventData.tabsHandlerOptions) === null || _eventData$tabsHandle === void 0 ? void 0 : _eventData$tabsHandle.path) || "";
    var baseRoute = ((_eventData$tabsHandle2 = eventData.tabsHandlerOptions) === null || _eventData$tabsHandle2 === void 0 || (_eventData$tabsHandle2 = _eventData$tabsHandle2.options) === null || _eventData$tabsHandle2 === void 0 ? void 0 : _eventData$tabsHandle2.baseRoute) || (triggerApp === null || triggerApp === void 0 ? void 0 : triggerApp.baseRoute) || "";

    // 拼接baseRoute
    if (path) {
      eventData.tabsHandlerOptions.path = baseRoute + eventData.tabsHandlerOptions.path;
    }

    // remove可选参数redirectPath,也需要拼接baseRoute
    var redirectPath = (_eventData$tabsHandle3 = eventData.tabsHandlerOptions) === null || _eventData$tabsHandle3 === void 0 || (_eventData$tabsHandle3 = _eventData$tabsHandle3.options) === null || _eventData$tabsHandle3 === void 0 ? void 0 : _eventData$tabsHandle3.redirectPath;
    path = ((_eventData$tabsHandle4 = eventData.tabsHandlerOptions) === null || _eventData$tabsHandle4 === void 0 ? void 0 : _eventData$tabsHandle4.path) || "";
    var realTargetPathInfo = getRealTargetPath(path);
    var realTargetRedirectPathInfo = redirectPath ? getRealTargetPath(baseRoute + redirectPath) : void 0;
    var redirectPathInfo = realTargetRedirectPathInfo !== null && realTargetRedirectPathInfo !== void 0 && realTargetRedirectPathInfo[0] ? {
      redirectPath: realTargetRedirectPathInfo.join("?")
    } : {};
    switch (eventData.tabsHandler) {
      case "add":
        pageHandlers.add(realTargetPathInfo.join("?"), (_eventData$tabsHandle5 = eventData.tabsHandlerOptions) === null || _eventData$tabsHandle5 === void 0 ? void 0 : _eventData$tabsHandle5.options);
        break;
      case "remove":
        pageHandlers.remove(path ? realTargetPathInfo[0] : void 0, _objectSpread(_objectSpread({}, (_eventData$tabsHandle6 = eventData.tabsHandlerOptions) === null || _eventData$tabsHandle6 === void 0 ? void 0 : _eventData$tabsHandle6.options), redirectPathInfo));
        break;
      default:
        (_pageHandlers$eventDa = pageHandlers[eventData.tabsHandler]) === null || _pageHandlers$eventDa === void 0 || _pageHandlers$eventDa.call(pageHandlers);
        break;
    }
  });
  useEffect(function () {
    // 注册子应用事件监听
    microApps.forEach(function (app) {
      microApp.addDataListener(app.name, function (data) {
        handleEventFromChild(app.name, data);
      });
    });
    return function () {
      microApps.forEach(function (app) {
        microApp.clearDataListener(app.name);
        microApp.clearData(app.name);
      });
    };
  }, []);
};